import { render } from "./device.vue?vue&type=template&id=4d5d0a31&scoped=true&ts=true"
import script from "./device.vue?vue&type=script&lang=ts"
export * from "./device.vue?vue&type=script&lang=ts"

import "./device.vue?vue&type=style&index=0&id=4d5d0a31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5d0a31"]])

export default __exports__